<template>
  <v-app>
    <!-- <div>-->
      <v-content>
        <v-container fluid class="maincontainer">
            <router-view ></router-view>
        </v-container>
      </v-content>
    <!-- </div> -->
    <v-dialog v-model="errordialog" width="500">
      <v-card>
        <v-card-title class="error" primary-title>
          Felmeddelande
        </v-card-title>
        <v-card-text>
          {{errormessage}}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="clearerror">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="workingdialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Sparar...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { HTTP } from '@/backend/client'
import { mapGetters } from 'vuex'

export default {
  name: 'app',
  data: function () {
    return {
      // issuperuser: false
    }
  },
  computed: {
    ...mapGetters('appcurrent', {
      isauthorized: 'isauthorized',
      bearertoken: 'bearertoken',
      errordialog: 'errordialog',
      errormessage: 'errormessage',
      workingdialog: 'workingdialog'
    }),
    feldialog: function () {
      return this.errormessage
    }
  },
  created () {
    this.checkCurrentLogin()
    this.$store.dispatch('appcurrent/initStorage')
    this.$i18n.locale = 'se'

    // HTTP.get('/kund/issuperuser/')
    //   .then(response => {
    //     this.issuperuser = response.data
    //   })
  },
  methods: {
    checkCurrentLogin () {
      if (this.$route.path.startsWith('/changepassword')) return
      if (this.$route.path.startsWith('/glomtlosen')) return
      if (HTTP.defaults.headers.common['Authorization'] === undefined && this.bearertoken !== 'undefined') {
        HTTP.defaults.headers.common['Authorization'] = 'Bearer ' + this.bearertoken
      }
      HTTP.get('/account/checkauthorization')
        .then(response => {
        })
        .catch(e => {
          // this.$store.dispatch('appcurrent/saveAuthorization', false)
          // this.error = e
          this.$router.push('/login')
        })
    },
    clearerror () {
      this.$store.dispatch('appcurrent/clearError')
    }
  }

}

</script>

<style lang="scss">
  // @import 'src/assets/app.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue